"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = _default;

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

function _default(url) {
  return new _promise.default(function (resolve, reject) {
    var existingTag = document.querySelector("script[src=\"".concat(url, "\"]"));

    if (existingTag) {
      var previousOnLoadCallback = existingTag.onload;

      existingTag.onload = function () {
        try {
          if (previousOnLoadCallback) {
            previousOnLoadCallback();
          }
        } catch (err) {
          window.console.error(err);
        }

        resolve();
      };

      return;
    }

    var script = document.createElement('script');
    script.onload = resolve;
    script.async = true;
    script.src = url;
    (document.head || document.getElementsByTagName('head')[0]).appendChild(script);
  });
}

//# sourceMappingURL=loadScript.js.map